import { apiClient } from "./core/client";
import type { InvoiceDto, InvoiceLineDto, CustomerDto, PaginatedResponse, PaymentMethod } from "@/types/dto";

export interface InvoiceLinePayload {
  description: string;
  quantity: number;
  unitPrice: number;
  total: number;
}

export interface CreateInvoicePayload {
  customerId: string;
  jobId?: string | null;
  storageRentalId?: string | null;
  subtotal: number;
  taxAmount: number;
  total: number;
  status?: string;
  paymentMethod?: PaymentMethod | null;
  dueDate: string;
  notes?: string | null;
  lines: InvoiceLinePayload[];
}

export type UpdateInvoicePayload = Partial<CreateInvoicePayload> & {
  paidAt?: string | null;
};

export interface InvoiceWithRelations extends InvoiceDto {
  customer: CustomerDto;
  lines: InvoiceLineDto[];
}

export async function getInvoices(params?: {
  page?: number;
  limit?: number;
  search?: string;
  customerId?: string;
  status?: string;
}) {
  const { data } = await apiClient.get<PaginatedResponse<InvoiceWithRelations>>(
    "/api/invoices",
    { params }
  );
  return data;
}

export async function getInvoice(id: string) {
  const { data } = await apiClient.get<InvoiceWithRelations>(`/api/invoices/${id}`);
  return data;
}

export async function createInvoice(payload: CreateInvoicePayload) {
  const { data } = await apiClient.post<InvoiceWithRelations>("/api/invoices", payload);
  return data;
}

export async function updateInvoice(id: string, payload: UpdateInvoicePayload) {
  const { data } = await apiClient.patch<InvoiceWithRelations>(`/api/invoices/${id}`, payload);
  return data;
}

export async function deleteInvoice(id: string) {
  await apiClient.delete(`/api/invoices/${id}`);
}
